module.exports = __webpack_public_path__ + "letchworth_state_park.6f94e66fe9d6146096f54f3d33262efd.png";